module.exports = __webpack_public_path__ + "img/linked-account.c952fa7e.jpg";